import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { usersAPI } from "@api";
import { setAlert } from '@store/alerts.reducer';

const showErrorAlert = (dispatch) => {
    dispatch(setAlert({
      title: 'Ошибка',
      text: 'Не удалось загрузить профиль ребенка',
      type: 'error'
    }));
};

export const fetchParentSelectedChild = createAsyncThunk(
  "parentSelectedChild/fetchParentSelectedChild",
  async (childrenId, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersAPI.getUser({ id: childrenId });
      if (response.status !== 200) {
        showErrorAlert(dispatch)
        return rejectWithValue('Ошибка сервера: неверный статус ответа');
      }
      return response.data;
    } 
    catch (error) {
        showErrorAlert(dispatch)
        return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: {},
  status: "idle",
  error: null,
};

const parentSelectedChildSlice = createSlice({
  name: 'parentSelectedChild',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchParentSelectedChild.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchParentSelectedChild.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
      })
      .addCase(fetchParentSelectedChild.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })
  },
});

export default parentSelectedChildSlice.reducer;